import html2pdf from "html2pdf.js";
import {appState, proposal} from "../../globalState";
import {getStorage, ref, uploadBytes} from "firebase/storage";

export async function downloadPDF(_, setPDFMode, setLink) {
    const element = document.querySelector(".pdfRenderer");
    const opt = {
        margin: 0,
        filename: "Tulu Proposal.pdf",
        image: {type: "jpeg", quality: 0.95},
        html2canvas: {
            scale: 1,
            allowTaint: true,
            useCORS: true,
            truedpi: 300,
            letterRendering: true,
        },
        jsPDF: {
            unit: "px",
            format: [1230, 1920],
            orientation: "l",
        },
    };

    setTimeout(async () => {
        html2pdf()
            .set(opt)
            .from(element)
            .output("blob")
            .then((pdf) => {
                appState.uploadStatus = "Uploading to Server...";
                const storage = getStorage();
                const storageRef = ref(storage, "proposals/" + proposal.buildingName + ".pdf");
                const metadata = {
                    contentType: pdf.contentType,
                };
                uploadBytes(storageRef, pdf, metadata).then((snapshot) => {
                    const newLink =
                        window.location.origin + "/myTulu/" + proposal.buildingName;

                    setLink && setLink(newLink);
                    setPDFMode && setPDFMode("saved");
                    appState.uploadStatus = "PDF Saved!";
                });


                // 'file' comes from the Blob or File API
            });
    }, 5000);
}
